import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlujoPolizaNavigationComponent } from '../../../comun/components/base/flujo-poliza-navigation.component';
import { PolizaSaludStoreService } from '../../services/store/poliza-salud-store.service';
import { ProductoDestacadoComponent } from './producto-destacado/producto-destacado.component';

@Component({
	selector: 'app-pymes',
	standalone: true,
	imports: [CommonModule, ProductoDestacadoComponent],
	templateUrl: './pymes.component.html',
	styleUrls: ['./pymes.component.scss']
})
export class PymesComponent {


}
